import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/**
 * Header band shared by every settings panel: an icon badge, the panel title,
 * an optional one-line description of what the panel controls, and the panel's
 * action buttons pushed to the right.
 *
 * Presentational only — the tabs own the data and the handlers.
 */
export default function SettingsPanelHeader({ icon, title, description, actions, dense }) {
    return (
        <Box
            component="header"
            sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1.75,
                px: dense ? 2 : 2.5,
                py: dense ? 1.5 : 2,
                borderBottom: "1px solid rgba(0, 40, 128, 0.08)",
            }}
        >
            {icon && (
                <Box
                    aria-hidden="true"
                    sx={{
                        flexShrink: 0,
                        width: dense ? 34 : 40,
                        height: dense ? 34 : 40,
                        borderRadius: "12px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        background: "linear-gradient(135deg, rgba(255,144,21,0.16), rgba(255,193,0,0.12))",
                        color: "#e07600",
                        fontSize: dense ? "15px" : "17px",
                    }}
                >
                    <i className={`pi ${icon}`} />
                </Box>
            )}

            {/* minWidth 0 so a long title ellipsizes instead of pushing the actions out */}
            <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                    component="h2"
                    sx={{
                        fontFamily: "roboto, sans-serif",
                        fontSize: dense ? "17px" : "20px",
                        fontWeight: 700,
                        lineHeight: 1.25,
                        color: "rgb(0, 40, 128)",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                >
                    {title}
                </Typography>
                {description && (
                    <Typography
                        sx={{
                            mt: 0.5,
                            fontFamily: "roboto, sans-serif",
                            fontSize: "13px",
                            lineHeight: 1.5,
                            color: "rgba(45, 42, 38, 0.62)",
                        }}
                    >
                        {description}
                    </Typography>
                )}
            </Box>

            {actions && (
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
                    {actions}
                </Box>
            )}
        </Box>
    );
}
